import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { NoteDialog } from '@components/job/dialogs/note';
import { Button } from '@components/ui/button';
import { useIsPhone } from '@hooks/useIsPhone';
import { cn } from '@utils/cn';
import { NoteBox } from '../../noteBox';
import { JobNoteCellProps } from './types';

export const JobNoteCell = ({
  referableType,
  data,
  jobId,
  typeId,
  disabled,
  open,
  setOpen,
}: JobNoteCellProps) => {
  const { t } = useTranslation('app');
  const { workflowId } = useParams();
  const isPhone = useIsPhone();
  const hasNote = Boolean(data?.content);
  const label = t(`pages.job.info.note.${hasNote ? 'update' : 'create'}`);

  return (
    <>
      <div className="hidden w-full xl:flex">
        <NoteBox
          referableType={referableType}
          data={data}
          jobId={jobId}
          typeId={typeId}
          disabled={disabled}
        />
      </div>
      {!workflowId && (
        <Button
          variant="ghost"
          disabled={disabled}
          aria-label={label}
          title={label}
          onClick={() => setOpen(true)}
          className={cn(
            'relative h-9 w-9 shrink-0 p-0 text-neutral-400 hover:text-primary-500 xl:hidden max-[899px]:h-11 max-[899px]:w-11',
            hasNote && 'text-primary-500',
          )}>
          <SvgConsumer
            id={hasNote ? 'editNote' : 'addNote'}
            className="text-m max-[899px]:text-lg"
          />
          {hasNote && (
            <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-primary-500 ring-2 ring-white" />
          )}
        </Button>
      )}
      <NoteDialog
        open={open}
        setOpen={setOpen}
        initialValues={{ ...data, jobId, typeId, referableType }}
        sheet={isPhone}
      />
    </>
  );
};
